var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Listening exercises ")]),_c('v-card-text',[_vm._v(" Coming soon ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }